import type { IValidationField } from '../types';
import * as yup from 'yup';

export default function string({ label = '', defaultValue = '' }: IValidationField) {
  return yup.string().label(label).default(defaultValue.toString());
}
